import React, { useState } from 'react';
import { useAuth } from '../services/AuthContext';
import { useNavigate, Link } from 'react-router-dom';
import {
  ButtonPrimary,
  Input,
  Alert,
  Spinner,
  Icon
} from '../components/ComponentLibrary';
import { LogIn, User, Lock, Mail } from 'lucide-react';
import logoImg from '../img/Untitled design (19).png';
import BackgroundLayout from '../components/BackgroundLayout';
import './Auth.css';

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();

  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleLogin = async (e) => {
    if (e) e.preventDefault();
    try {
      setLoading(true);
      setError('');
      const { user } = await login(email, password);

      if (user.role === 'admin') {
        navigate('/admin/dashboard', { replace: true });
      } else if (user.role === 'instructor') {
        navigate('/instructor', { replace: true });
      } else {
        navigate('/', { replace: true });
      }
    } catch (err) {
      console.error('Login error:', err);
      setError(err.message || 'خطأ في البريد الإلكتروني أو كلمة المرور');
    } finally {
      setLoading(false);
    }
  };



  return (
    <BackgroundLayout>
      <div className="auth-page">
        <div className="auth-container">
          <div className="auth-card">
            <header className="auth-header">
              <img
                src={logoImg}
                alt="Code Wave Logo"
                className="auth-logo-img"
                width="84"
                height="84"
                loading="eager"
              />
              <h1 className="auth-title">مرحباً بك مجدداً <Icon name="sparkles" size={28} /></h1>
              <p className="auth-subtitle">سجل دخولك لتكمل رحلتك التعليمية</p>
            </header>

            {error && (
              <Alert variant="error" className="mb-6">
                {error}
              </Alert>
            )}

            <form onSubmit={handleLogin} className="auth-form">
              <div className="form-group">
                <label className="form-label">البريد الإلكتروني</label>
                <Input
                  type="email"
                  icon={<Mail size={18} />}
                  placeholder="name@example.com"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  disabled={loading}
                  required
                />
              </div>

              <div className="form-group">
                <label className="form-label">كلمة المرور</label>
                <div className="password-input-container">
                  <Input
                    type={showPassword ? "text" : "password"}
                    icon={<Lock size={18} />}
                    placeholder="••••••••"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    disabled={loading}
                    required
                  />
                  <button
                    type="button"
                    className="password-toggle-btn"
                    onClick={() => setShowPassword(!showPassword)}
                    tabIndex="-1"
                  >
                    <Icon name={showPassword ? "eye_off" : "eye"} size={20} />
                  </button>
                </div>
              </div>

              <ButtonPrimary
                type="submit"
                className="auth-btn"
                disabled={loading}
                size="lg"
                fullWidth={true}
              >
                {loading ? <Spinner size="sm" /> : <>تسجيل الدخول <Icon name="logout" size={20} className="ml-2" /></>}
              </ButtonPrimary>
            </form>



            <div className="auth-footer">
              مهتم بالاشتراك؟ <Link to="/register" className="auth-link">تواصل مع CodeWave <Icon name="sparkles" size={16} /></Link>
            </div>
          </div>
        </div>
      </div>
    </BackgroundLayout>
  );
}
